/*
 * Employee Management
 */
import React from "react";
import { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Checkbox,
  Tooltip,
  Table,
  Space,
  Drawer,
  Modal,
  Tag,
  Radio,
  Collapse,
  // Dropdown,
  // Menu
} from "antd";

import { isEmpty } from "lodash";
import { Typography, Image } from "antd";
import { toast, ToastContainer } from "react-toastify";
import {
  FilterOutlined,
  ReloadOutlined,
  InfoCircleOutlined,
  DownloadOutlined,
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
  SafetyOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  SearchOutlined,
  //  DownOutlined,
} from "@ant-design/icons";
import "../Dashboard/index.css";
import "../EmployeeManagement/index.css";
import BreadcrumbComponent from "../../components/BreadCrumb";
import SimpleReactValidator from "simple-react-validator";
import { CloudUploadOutlined } from "@ant-design/icons";
import api from "../../helpers";
import { useSelector, useDispatch } from "react-redux";
import * as employeeAction from "../../store/Employee/actions";
import dayjs from "dayjs";
//bread crumb
const BCrumb = [{ to: "/", title: "Home" }, { title: "Employee Management" }];

const EmployeeManagementDetails = () => {
  const specificDispatch = useDispatch();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("userType");
  const [isModalOpen, setIsModalOpen] = useState(false);
  //Validations
  const simpleValidator = React.useRef(
    new SimpleReactValidator({
      validators: {
        passwordRule: {
          message:
            "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.",
          rule: (val) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
              val
            ),
          required: true,
        },
        passwordMatch: {
          message: "Passwords do not match.",
          rule: (val, params) => val === params[0],
          required: true,
        },
      },
    })
  );
  const [empId, setEmpId] = useState();
  const [, forceUpdate] = React.useState();
  const [form] = Form.useForm();
  const [filteredData, setFilteredData] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    specificDispatch(
      employeeAction.loadEmployee({
        limit: 10,
        page: 1,
        status: "BOTH"
      })
    );
    specificDispatch(employeeAction.loadDropdown());
  }, [specificDispatch]);

  //dropdown state from reducer
  const dropdownUpdate = useSelector((specificstate) => specificstate.Employee);
  const { dropDownList = {}, employee_list = {} } = dropdownUpdate;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(employee_list?.count); // get this from your API response
  useEffect(() => {
    if (employee_list) {
      setTotalCount(employee_list?.count); // total is total count of records in the backend
    }
  }, [employee_list]);

  //filter initial data
  const [employeeData, setEmployeeData] = useState({
    employeeCode: "",
    mobile: "",
    dojFrom: "",
    dojTo: "",
  });

  //filter dropdown initial value
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [city, setCity] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);

  //initial data
  const [employeeModal, setEmployeeModal] = useState({
    empName: "",
    mobileno: "",
    email: "",
    dob: "",
    pincode: "",
    employeeCode: "",
    officialMail1: "",
    officialMail2: "",
    officialMobile: "",
    doj: "",
    notes: "",
    userCode: "",
    password: "",
    confirmPassword: "",
    addressLine1: "",
    addressLine2: "",
    maritalStatus: "",
  });
  //edit state
  // const [isEdit, setIsEdit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  // dropdown initial value
  const [cities, setCities] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [bloodGroups, setBloodGroups] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [role, setRole] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [gender, setGender] = useState([]);
  const [isSL, setIsSL] = useState("");
  const [isCL, setIsCL] = useState("");
  const [employeeType, setEmployeeType] = useState([]);

  // static dropdown options
  const bloodGroupsOptions = [
    { Typography: "A+", value: "A+" },
    { Typography: "A-", value: "A-" },
    { Typography: "B+", value: "B+" },
    { Typography: "B-", value: "B-" },
    { Typography: "AB+", value: "AB+" },
    { Typography: "AB-", value: "AB-" },
    { Typography: "O+", value: "O+" },
    { Typography: "O-", value: "O-" },
  ];
  const genderOptions = [
    { Typography: "Male", value: "Male" },
    { Typography: "Female", value: "Female" },
    { Typography: "Others", value: "Others" },
  ];
  // profile picture initial values
  const [fileNames, setFileNames] = useState("");
  const [imagePreviews, setImagePreviews] = useState([]);
  //pofile picture on change and api functionality
  const handleSinglePhoto = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    setFileNames(fileArray[0].name);

    // Upload
    const uploadPromises = fileArray.map((file) => {
      const formData = new FormData();
      formData.append("profilePicture", file);
      return api
        .post("/auth/employee/upload-image", formData)
        .then((res) => {
          if (res?.status === 200 && res?.data?.file) {
            toast.success("Image uploaded successfully!", {
              containerId: "toast-1",
            });
            return {
              url: res.data.file,
              name: res.data.file,
            };
          } else {
            const errorMsg = res?.data?.error?.message || "Upload failed.";
            toast.error(errorMsg, { containerId: "toast-1" });
            return null;
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.error?.message || "Upload error occurred.";
          toast.error(errorMsg, { containerId: "toast-1" });
          return null;
        });
    });

    const uploadedImages = await Promise.all(uploadPromises);
    const validUploads = uploadedImages.filter(Boolean);
    setImagePreviews(validUploads);
  };
  const designationOptions = !isEmpty(dropDownList.designationOptions)
    ? dropDownList.designationOptions.filter(
      (item) => item.departmentId === departments.value
    )
    : [];

  const designationOptionsValue = !isEmpty(dropDownList.designationOptions)
    ? dropDownList.designationOptions.filter(
      (item) => item.departmentId === department.value
    )
    : [];
  console.log(dropDownList, "dropdDownList");
  //image preview handler
  const handleRemovePreview = (urlToRemove) => {
    setImagePreviews([]);
    setFileNames("");
    URL.revokeObjectURL(urlToRemove);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState("");

  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);

  const showSecondModal = (actionType) => {
    setIsSecondModalOpen(true);
  };

  const handleSecondModalCancel = () => {
    setIsSecondModalOpen(false);
  };
  //searchInput
  const [searchInput, setSearchInput] = useState("");
  // appove modal
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const handleApproveModalCancel = () => setApproveModalOpen(false);

  //checkbox handling
  const handleSLChange = (e) => {
    if (e.target.checked) {
      setIsSL(true);
    } else {
      setIsSL("");
    }
  };

  const handleCLChange = (e) => {
    if (e.target.checked) {
      setIsCL(true);
    } else {
      setIsCL("");
    }
  };

  //modal input handler
  const handleModalChange = (e) => {
    const { name, value } = e.target;

    setEmployeeModal((prevData) => ({
      ...prevData,
      [name]: value,
      // Auto-fill userCode when employeeCode is entered/changed
      ...(name === "employeeCode" && { userCode: value }),
    }));
  };

  //filter input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //filter date handler
  const handleDateChange = (name, value) => {
    setEmployeeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //modal date handler
  const handleModalDateChange = (name, value) => {
    setEmployeeModal((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //filter reset functionality
  const onReset = () => {
    setSearchInput("");
    setResetLoading(true);
    setTimeout(() => {
      form.resetFields();
      setEmployeeData({
        employeeCode: "",
        mobile: "",
        dojFrom: "",
        dojTo: "",
      });
      setDepartment([]);
      setDesignation([]);
      setCity([]);
      setEmployeeTypes([]);
      setFilteredData([]);
      setResetLoading(false);
    }, 1000);
    dispatch(
      employeeAction.loadEmployee({
        limit: 10,
        page: 1,
        status: "BOTH"
      })
    );
  };

  //filter functionality
  const [searchValue, setSearchValue] = useState({
    limit: 10,
    page: 1,
    status: "BOTH"
  });
  const handleFilter = (e) => {
    e.preventDefault();
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    let searchFilter = {};
    searchFilter.limit = pageSize;
    searchFilter.page = currentPage;
    searchFilter.status = "BOTH";
    if (employeeData.dojFrom)
      searchFilter.joinDate = employeeData.dojFrom.format("YYYY-MM-DD");
    if (employeeData.dojTo)
      searchFilter.tojoinDate = employeeData.dojTo.format("YYYY-MM-DD");
    if (employeeData.employeeCode)
      searchFilter.employeeCode = employeeData.employeeCode;
    if (employeeData.mobile) searchFilter.mobileNumber = employeeData.mobile;
    if (!isEmpty(department)) searchFilter.departmentId = department.value;
    if (!isEmpty(designation)) searchFilter.designationId = designation.value;
    if (!isEmpty(city)) searchFilter.city = city.value;

    setSearchValue(searchFilter);
    //dispatch
    if (!isEmpty(searchFilter)) {
      dispatch(employeeAction.loadEmployee(searchFilter));
    } else {
      dispatch(employeeAction.loadEmployee({ limit: 10, page: 1,status:"BOTH" }));
    }
  };

  const handleEdit = (employeeData) => {
    setIsEdit(true);
    setEmployeeModal({
      empName: employeeData.employeeName,
      mobileno: employeeData.mobileNumber.toString(),
      email: employeeData.emailId,
      dob: employeeData.dob ? dayjs(employeeData.dob) : null,
      pincode: employeeData.pincode,
      employeeCode: employeeData.employeeCode,
      officialMail1: employeeData.officialMail1,
      officialMail2: employeeData.officialMail2,
      officialMobile: employeeData.officialPhoneNo.toString(),
      doj: employeeData.doj ? dayjs(employeeData.doj) : null,
      notes: employeeData.notes,
      userCode: employeeData.userName,
      password: employeeData.password,
      confirmPassword: employeeData.confirmPassword,
      addressLine1: employeeData.addressLine1,
      addressLine2: employeeData.addressLine2,
      maritalStatus: employeeData.maritalStatus,
    });
    simpleValidator.current.message(
      "mobileno",
      employeeModal.mobileno,
      "required|numeric|min:10|max:10"
    );
    forceUpdate((n) => n + 1);
    if (employeeData.departmentId && employeeData.departmentName) {
      setDepartments({
        label: employeeData.departmentName,
        value: employeeData.departmentId,
      });
    } else {
      setDepartments([]);
    }

    if (employeeData.designationId && employeeData.designationName) {
      setDesignations({
        label: employeeData.designationName,
        value: employeeData.designationId,
      });
    } else {
      setDesignations([]);
    }

    if (employeeData.employeeTypeId && employeeData.employeeTypeId) {
      setEmployeeType({
        label: employeeData.employeeTypeId.employeeType,
        value: employeeData.employeeTypeId.employeeTypeId,
      });
    } else {
      setEmployeeType([]);
    }

    if (employeeData.roleId && employeeData.role) {
      setRole({ label: employeeData.role, value: employeeData.roleId });
    } else {
      setRole([]);
    }

    if (employeeData.cityId && employeeData.cities) {
      setCities({ label: employeeData.cities, value: employeeData.cityId });
    } else {
      setCities([]);
    }

    if (employeeData.gender) {
      setGender({ label: employeeData.gender, value: employeeData.gender });
    } else {
      setGender([]);
    }

    if (employeeData.stateId && employeeData.stateList) {
      setStateList({
        label: employeeData.stateList,
        value: employeeData.stateId,
      });
    } else {
      setStateList([]);
    }

    if (employeeData.bloodGroups) {
      setBloodGroups({
        label: employeeData.bloodGroups,
        value: employeeData.bloodGroups,
      });
    } else {
      setBloodGroups([]);
    }

    if (employeeData.shifts && employeeData.shifts._id) {
      setShifts({
        label: employeeData.shifts.shiftName,
        value: employeeData.shifts._id,
      });
    } else {
      setShifts([]);
    }

    setIsCL(employeeData.isCL);
    setIsSL(employeeData.isSL);

    setIsModalOpen(true);

    if (employeeData.profilePicture) {
      setFileNames(employeeData.profilePicture);
      setImagePreviews([
        {
          url: employeeData.profilePicture,
          name: employeeData.profilePicture,
        },
      ]);
    } else {
      setImagePreviews([]);
    }
  };

  const [empCode, setEmpCode] = useState("");

  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: <span className="poppins-txt">Action</span>,
      dataIndex: "action",
      width: 130,
      render: (_, record) =>
        userType === "admin" && (
          <Space style={{ gap: "8px" }}>
            <Button
              style={{
                background: "#34c38f",
                border: "none",
                minWidth: 30,
                height: 30,
                padding: "2px 4px",
                fontSize: "0.75rem",
              }}
              onClick={() => {
                handleEdit(record);
                setEmpId(record._id);
              }}
            >
              <EditOutlined
                style={{
                  color: "#ffff",
                  fontSize: 14,
                }}
              />
            </Button>
            <Button
              style={{
                background: "#f46a6a",
                border: "none",
                minWidth: 30,
                height: 30,
                padding: "2px 4px",
                fontSize: "0.75rem",
              }}
              onClick={() => {
                showModalOpen("delete");
                setEmpId(record._id);
                setSelectedRow([]);
              }}
            >
              <DeleteOutlined
                style={{
                  color: "#ffff",
                  fontSize: 14,
                }}
              />
            </Button>
            <Button
              style={{
                border: "none",
                minWidth: 30,
                height: 30,
                padding: "2px 4px",
                fontSize: "0.75rem",
              }}
              type="primary"
              onClick={() => {
                setApproveModalOpen(true);
                setEmpId(record._id);
              }}
            >
              <SafetyOutlined
                style={{
                  color: "#ffff",
                  fontSize: 18,
                }}
              />
            </Button>
          </Space>
        ),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Employee Code
        </span>
      ),
      dataIndex: "employeeCode",
      width: 160,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeCode.localeCompare(b.employeeCode),
    },
    {
      title: <span className="poppins-txt">Name</span>,
      dataIndex: "employeeName",
      width: 90,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeName.localeCompare(b.employeeName),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Mobile Number
        </span>
      ),
      dataIndex: "mobileNumber",
      width: 160,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.mobileNumber.localeCompare(b.mobileNumber),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Official Email
        </span>
      ),
      dataIndex: "emailId",
      width: 130,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.emailId.localeCompare(b.emailId),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Department
        </span>
      ),
      dataIndex: "departments",
      width: 130,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.departments.localeCompare(b.departments),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Designation
        </span>
      ),
      dataIndex: "designations",
      width: 130,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.designations.localeCompare(b.designations),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Password
        </span>
      ),
      dataIndex: "password",
      width: 130,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.password.localeCompare(b.password),
      render: (text, record) => (
        <Space>
          <span className="poppins-txt-lg">
            {visiblePasswords[record.employeeCode]
              ? record.password
              : "••••••••"}
          </span>
          <Button
            style={{ border: "none", background: "transparent" }}
            onClick={() => togglePasswordVisibility(record.employeeCode)}
          >
            {visiblePasswords[record.employeeCode] ? (
              <EyeInvisibleOutlined />
            ) : (
              <EyeOutlined />
            )}
          </Button>
          <Button
            className="custom-btn mt-2"
            type="primary"
            size="medium"
            onClick={() => {
              showSecondModal("Reset");
              setEmpCode(record.employeeCode);
            }}
          >
            Reset
          </Button>
        </Space>
      ),
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Status
        </span>
      ),
      dataIndex: "status",
      width: 100,
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (status) => {
        const isActive = status=== 1;
        return (
          <Tag
            style={{
              backgroundColor: isActive ? "#e6f4d7" : "#fae1e1",
              color: isActive ? "#34c38f" : "#f46a6a",
              fontWeight: 500,
              width: 60,
              height: 20,
              paddingTop: "2px",
              fontSize: "11px",
              textAlign: "center",
              lineHeight: "16px",
              borderRadius: 4,
              border: "none",
              fontFamily: "Poppins",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
  ];

  const tableData =
    employee_list && !isEmpty(employee_list.data)
      ? employee_list.data.map((data, index) => {
        return {
          _id: data._id,
          sno: index + 1,
          employeeName: data.employeeName || "--",
          mobileNumber: data.mobileNumber || "--",
          emailId: data.emailId || "--",
          dob: data.DOB ? data.DOB : "",
          gender: data.gender || "",
          addressLine1: data.addressLine1 || "",
          addressLine2: data.addressLine2 || "",
          cities: data.city ? data.city.cityName : "",
          cityId: data.city ? data.city._id : "",
          stateList: data.state ? data.state.stateName : "",
          stateId: data.state ? data.state._id : "",
          pincode: data.pincode || "",
          bloodGroups: data.bloodGroup || "",
          maritalStatus: data.maritalStatus || "",
          profilePicture: data.profilePicture || "",
          departments: data.departmentId
            ? data.departmentId.departmentName
            : "--",
          departmentName: data.departmentId
            ? data.departmentId.departmentName
            : "",
          departmentId: data.departmentId ? data.departmentId._id : "",
          designations: data.designationId
            ? data.designationId.designationName
            : "--",
          designationName: data.designationId
            ? data.designationId.designationName
            : "",
          designationId: data.designationId ? data.designationId._id : "",
          role: data.roleId ? data.roleId.role : "",
          roleId: data.roleId ? data.roleId._id : "",
          employeeCode: data.employeeCode || "--",
          officialMail1: data.officialMail1 || "",
          officialMail2: data.officialMail2 || "",
          officialPhoneNo: data.officialPhoneNo || "",
          doj: data.joinDate || "",
          shifts: data.workShift || "",
          isCL: data.isCl ?? false,
          isSL: data.isSl ?? false,
          userCode: data.createdBy?.userName || "",
          password: data.password || "",
          confirmPassword: data.password || "",
          status: data.status,
          notes: data.notes || "",
          userName: data.userName || "",
          employeeTypeId: data.employeeTypeId,
        };
      })
      : [];

  //download csv
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const [downloadLoader, setDownloadLoader] = useState(false);

  const exportToCsv = async () => {
    setDownloadLoader(true);
    let searchFilter = {};

    if (employeeData.dojFrom)
      searchFilter.joinDate = employeeData.dojFrom.format("YYYY-MM-DD");
    if (employeeData.dojTo)
      searchFilter.tojoinDate = employeeData.dojTo.format("YYYY-MM-DD");
    if (employeeData.employeeCode)
      searchFilter.employeeCode = employeeData.employeeCode;
    if (employeeData.mobile) searchFilter.mobileNumber = employeeData.mobile;
    if (!isEmpty(department)) searchFilter.departmentId = department;
    if (!isEmpty(designation)) searchFilter.designationId = designation;
    if (!isEmpty(city)) searchFilter.city = city;
    try {
      const res = await api.post("/auth/employee/getallemployee", searchFilter);
      const employees = res.data?.data || [];

      const mappedData = employees.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        employeeName: data.employeeName || "--",
        mobileNumber: data.mobileNumber || "--",
        emailId: data.emailId || "--",
        dob: data.DOB || "",
        gender: data.gender || "",
        addressLine1: data.addressLine1 || "",
        addressLine2: data.addressLine2 || "",
        cities: data.city?.cityName || "",
        cityId: data.city?._id || "",
        stateList: data.state?.stateName || "",
        stateId: data.state?._id || "",
        pincode: data.pincode || "",
        bloodGroups: data.bloodGroup || "",
        maritalStatus: data.maritalStatus || "",
        profilePicture: data.profilePicture || "",
        departments: data.departmentId?.departmentName || "--",
        departmentName: data.departmentId?.departmentName || "",
        departmentId: data.departmentId?._id || "",
        designations: data.designationId?.designationName || "--",
        designationName: data.designationId?.designationName || "",
        designationId: data.designationId?._id || "",
        role: data.roleId?.role || "",
        roleId: data.roleId?._id || "",
        employeeCode: data.employeeCode || "--",
        officialMail1: data.officialMail1 || "",
        officialMail2: data.officialMail2 || "",
        officialPhoneNo: data.officialPhoneNo || "",
        doj: data.joinDate || "",
        shifts: data.workShift || "",
        isCL: data.isCl ?? false,
        isSL: data.isSl ?? false,
        userCode: data.createdBy?.userName || "",
        password: data.password || "",
        confirmPassword: data.password || "",
        status: data.status === 1 ? "Active" : "Inactive",
        notes: data.notes || "",
        employeeType: data.employeeTypeId || "",
        employeeTypeId: employeeType.value,
      }));

      // Only include fields for CSV that you want:
      const headers = [
        "S.No",
        "Employee Code",
        "Name",
        "Mobile Number",
        "Official Email",
        "Department",
        "Designation",
        "Password",
        "Status",
      ];

      const csvRows = mappedData.map((item) => [
        item.sno,
        item.employeeCode,
        item.employeeName,
        item.mobileNumber,
        item.emailId,
        item.departments,
        item.designations,
        item.password,
        item.status,
      ]);

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "employee-management.csv",
        fileType: "text/csv",
      });
    } catch (error) {
      if (error) {
        setDownloadLoader(false);
      }
    } finally {
      setDownloadLoader(false);
    }
  };

  // modal handling
  const showModalOpen = (type) => {
    setModalType(type);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setModalType("");
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // modal clear data
  const clearModelData = () => {
    setEmployeeModal({
      empName: "",
      mobileno: "",
      email: "",
      dob: "",
      pincode: "",
      employeeCode: "",
      officialMail1: "",
      officialMail2: "",
      officialMobile: "",
      doj: "",
      notes: "",
      userCode: "",
      password: "",
      confirmPassword: "",
      addressLine1: "",
      addressLine2: "",
      maritalStatus: "",
    });

    setCities([]);
    setStateList([]);
    setBloodGroups([]);
    setDepartments([]);
    setDesignations([]);
    setRole([]);
    setShifts([]);
    setGender([]);
    setIsSL("");
    setIsCL("");
    setEmployeeType([]);

    setFileNames([]);
    setImagePreviews([]);
  };

  // show modal functionality
  const showModal = () => {
    setIsEdit(false);
    setIsModalOpen(true);
    simpleValidator.current.hideMessages();
    simpleValidator.current.hideMessageFor("password");
    simpleValidator.current.hideMessageFor("officialMobile");
    simpleValidator.current.hideMessageFor("officialMail2");
    simpleValidator.current.hideMessageFor("officialMail1");
    simpleValidator.current.hideMessageFor("mobileno");
    simpleValidator.current.hideMessageFor("email");
    forceUpdate(3);
    clearModelData();
  };

  const [disabled, setDisabled] = useState(false);

  // handle submit employee
  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true); // Disable the button
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);

    if (simpleValidator.current.allValid()) {
      const employeePayload = {
        employeeName: employeeModal.empName,
        departmentId: departments.value,
        designationId: designations.value,
        roleId: role.value,
        employeeCode: employeeModal.employeeCode,
        password: employeeModal.password,
        confirmPassword: employeeModal.confirmPassword,
        officialMail1: employeeModal.officialMail1,
        mobileNumber: employeeModal.mobileno,
        emailId: employeeModal.email,
        status: 1,
        addressLine1: employeeModal.addressLine1,
        city: cities.value,
        workShift: shifts.value,
        pincode: employeeModal.pincode,
        userName: employeeModal.userCode,
        employeeTypeId: employeeType.value,
        // Optional fields
        ...(employeeModal.dob && {
          DOB: employeeModal.dob.format("YYYY-MM-DD"),
        }),
        ...(employeeModal.addressLine2 && {
          addressLine2: employeeModal.addressLine2,
        }),
        ...(gender?.value && { gender: gender.value }),
        ...(bloodGroups?.value && { bloodGroup: bloodGroups.value }),
        ...(stateList?.value && { state: stateList.value }),
        ...(employeeModal.maritalStatus && {
          maritalStatus: employeeModal.maritalStatus,
        }),
        ...(employeeModal.notes && { notes: employeeModal.notes }),
        ...(employeeModal.officialMail2 && {
          officialMail2: employeeModal.officialMail2,
        }),
        ...(employeeModal.officialMobile && {
          officialPhoneNo: employeeModal.officialMobile,
        }),
        ...(employeeModal.doj && {
          joinDate: employeeModal.doj.format("YYYY-MM-DD"),
        }),
        ...(isCL && { isCl: isCL }),
        ...(isSL && { isSl: isSL }),
        ...(!isEmpty(imagePreviews) && {
          profilePicture: imagePreviews[0].url,
        }),
      };

      if (!isEdit) {
        api
          .post("/auth/employee/addemployee", employeePayload)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              dispatch(employeeAction.loadEmployee(searchValue));
              toast.success("Employee added successfully");
            } else {
              toast.warning(response?.data?.msg || "");
            }
            setIsModalOpen(false);
            return response.data;
          })
          .catch((err) => {
            const errorMsg =
              err?.response?.data?.message ||
              "An error occurred while adding the Employee";
            toast.error(errorMsg, { containerId: "toast-1" });
            return Promise.reject(err);
          });
      } else {
        api
          .post(`/auth/employee/updateemployee/${empId}`, employeePayload)

          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              dispatch(employeeAction.loadEmployee(searchValue));
              toast.success("Employee updated successfully");
            } else {
              toast.warning(response?.data?.msg || "");
            }
            setIsModalOpen(false);
            return response.data;
          })
          .catch((err) => {
            const errorMsg =
              err?.response?.data?.message ||
              "An error occurred while updating the employee";
            toast.error(errorMsg, "error", { containerId: "toast-1" });
            return Promise.reject(err);
          });
      }
      //  setIsEdit(false);
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setIsModalOpen(true);
    }
  };

  const [visiblePasswords, setVisiblePasswords] = useState({});

  const togglePasswordVisibility = (key) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  //status handling

  const handleUpdateStatus = (statusType) => {
    setDisabled(true); // Disable the button
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);

    const statusMap = {
      delete: 3,
      active: 1,
      inactive: 2,
    };

    const toastMessage = {
      delete: "Employee deleted successfully",
      active: "Employee activated successfully",
      inactive: "Employee deactivated successfully",
    };

    const statusValue = statusMap[statusType];
    if (!statusValue) return;
    const id = !isEmpty(selectedRow) ? selectedRow : [empId];
    const payload = {
      id: id, // use selectedRow instead of hardcoded ID
      status: statusValue,
    };

    api
      .post("/auth/employee/updateemployee", payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(employeeAction.loadEmployee(searchValue));
          toast.success(toastMessage[statusType]);
          setApproveModalOpen(false);
          setSelectedRow([]);
          handleModalClose();
        } else {
          toast.warning(response?.data?.msg || "Unexpected response");
        }
        return response.data;
      })
      .catch((err) => {
        const errorMsg =
       err?.response?.data?.error||err?.response?.data?.message ||
          "An error occurred while updating the employee status";
           setSelectedRow([]);
          handleModalClose();
        toast.error(errorMsg);
        return Promise.reject(err);
      });
  };

  //update approval
  const handleApproveUpdate = () => {
    const payload = {
      id: [empId],
      webAccess: true,
      status: 1,
    };
    api
      .post("/auth/employee/updateemployee", payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(employeeAction.loadEmployee(searchValue));
          toast.success("Employee approved successfully");
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setApproveModalOpen(false);
        return response.data;
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.message ||
          "An error occurred while approving the employee";
        toast.error(errorMsg);
        return Promise.reject(err);
      });
  };

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
      page: currentPage,
      limit: pageSize,
       status :"BOTH"
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(employeeAction.loadEmployee(payload));
  };

  //reset password
  const handleResetPassword = () => {
    const reset = {
      employeeCode: empCode,
    };
    api
      .post("/auth/employee/passwordreset", reset)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(employeeAction.loadEmployee(searchValue));
          toast.success("Password reseted successfully");
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setIsSecondModalOpen(false);
        return response.data;
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.message ||
          "An error occurred while reset the password";
        toast.error(errorMsg);
        return Promise.reject(err);
      });
  };
  //collapse
  const { Panel } = Collapse;

  // const toggleMenu = (
  //   <Menu
  //     items={[
  //       { key: "1", label: "Show all" },
  //       { key: "2", label: "Only active" },
  //       { key: "3", label: "Only inactive" },
  //     ]}
  //   />
  // );

  // Custom header with filer icon and dropdown on the right
  const collapseHeader = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginLeft: "5px",
        fontFamily: "Poppins",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FilterOutlined />
        <span className="poppins-txt" style={{ fontWeight: 500 }}>
          Apply Filter
        </span>
      </div>
    </div>
  );
  // city options
  const cityOptions = !isEmpty(dropDownList.cityOptions)
    ? dropDownList.cityOptions.filter((city) => city.stateId === stateList.value)
    : [];

  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Employee Management | Mequals</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Employee Management" items={BCrumb} />
        </Col>
        <Col>
          <Button
            className="custom-btn mt-2"
            type="primary"
            size="medium"
            onClick={showModal}
          >
            Add Employee
          </Button>
        </Col>
      </Row>

      <Drawer
        className="custom-drawer"
        placement="right"
        onClose={handleCancel}
        open={isModalOpen}
        width="100%"
        closable={false}
        title={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "20px",
            }}
            className="poppins-txt"
          >
            <span>{isEdit ? "Edit Employee" : "Add Employee"}</span>
            {/* Add Employee */}
            <CloseOutlined
              onClick={handleCancel}
              style={{ fontSize: 18, cursor: "pointer" }}
            />
          </div>
        }
        footer={
          <div
            style={{
              position: "fixed",
              bottom: 0,
              width: "100%",
              background: "#fff",
              borderTop: "1px solid #f0f0f0",
              padding: "10px 24px",
              display: "flex", // Added flexbox for layout
              justifyContent: "flex-end", // Align buttons to the right
              gap: "10px", // Adds space between buttons
              zIndex: 1001,
            }}
          >
            <Button
              className="custom-btn"
              key="cancel"
              style={{
                background: "#f46a6a",
                color: "white",
                marginRight: "10px",
              }}
              onClick={handleCancel}
            >
              Cancel
            </Button>

            <Button
              className="custom-btn"
              key="save"
              disabled={disabled}
              style={{
                background: "#34c38f",
                color: "white",
                marginRight: "22px",
              }}
              onClick={handleSubmit}
            >
              {isEdit ? "Update" : "Save"}
              {/* Save */}
            </Button>
          </div>
        }
      >
        <div>
          <Row gutter={16}>
            <Col xs={24} style={{ fontFamily: "Poppins" }}>
              <h4
                style={{
                  fontSize: "16px",
                  color: "#1890ff",
                  cursor: "pointer",
                  display: "inline-flex",
                  gap: "8px",
                  maginTop: "5px",
                }}
                className="poppins-txt"
              >
                General Information
                <Tooltip
                  title="General Information"
                  color="#1890ff"
                  placement="rightTop"
                >
                  <InfoCircleOutlined
                    style={{
                      fontSize: "16px",
                      color: "#1890ff",
                      cursor: "pointer",
                    }}
                    className="poppins-txt"
                  ></InfoCircleOutlined>
                </Tooltip>
              </h4>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Name<span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input
                placeholder="Enter name"
                className="custom-select py-3"
                name="empName"
                value={employeeModal.empName}
                onChange={(e) => handleModalChange(e)}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block", // Make margin-top work
                }}
              >
                {simpleValidator.current.message(
                  "name",
                  employeeModal.empName,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography style={{ fontFamily: "Poppins" }}>
                Mobile No
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              {/* <Input
                placeholder="Enter mobile number"
                className="custom-select py-3"
                name="mobileno"
                value={employeeModal.mobileno}
                onChange={(e) => {
                  //  const onlyNums = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);

                  // Update state first
                  handleModalChange(e);

                  // Trigger validation with the current value
                  simpleValidator.current.showMessageFor(
                    "mobileno",
                    employeeModal.mobileno,
                    "required|numeric|min:10|max:10"
                  );

                  // Force re-render
                  forceUpdate((prev) => prev + 1);
                }}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              /> */}
              <Input
                placeholder="Enter mobile number"
                className="custom-select py-3"
                name="mobileno"
                value={employeeModal.mobileno}
                onChange={(e) => {
                  const onlyNums = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);

                  setEmployeeModal((prev) => ({
                    ...prev,
                    mobileno: onlyNums,
                  }));

                  // Trigger validation with the new value
                  simpleValidator.current.showMessageFor("mobileno");

                  // Force re-render
                  forceUpdate((prev) => prev + 1);
                }}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "mobileno",
                  employeeModal.mobileno,
                  "required|numeric|min:10|max:10"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Email ID
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input
                type="email"
                placeholder="Enter email"
                className="custom-select py-3"
                name="email"
                value={employeeModal.email}
                onChange={(e) => {
                  handleModalChange(e);

                  simpleValidator.current.showMessageFor(
                    "email",
                    employeeModal.email,
                    "email"
                  );

                  forceUpdate((prev) => prev + 1);
                }}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "email",
                  employeeModal.email,
                  "required|email"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">DOB</Typography>
              <DatePicker
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
                className="custom-select py-3"
                name="dob"
                value={employeeModal.dob}
                onChange={(date) => handleModalDateChange("dob", date)}
                autoComplete="off"
              />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography style={{ fontFamily: "Poppins" }}>Gender</Typography>
              <Select
                placeholder="Select gender"
                allowClear
                style={{ marginTop: "5px", width: "100%" }}
                name="gender"
                value={gender}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setGender({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setGender({ label: "", value: "" });
                  }
                }}
                className="custom-select "
                options={genderOptions}
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography style={{ fontFamily: "Poppins" }}>
                Blood Group
              </Typography>
              <Select
                placeholder="Select blood group"
                allowClear
                style={{ marginTop: "5px", width: "100%" }}
                name="bloodGroups"
                value={bloodGroups}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setBloodGroups({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setBloodGroups({ label: "", value: "" });
                  }
                }}
                className="custom-select "
                options={bloodGroupsOptions}
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Address 1
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input
                type="text"
                placeholder="Enter address 1"
                className="custom-select py-3"
                name="addressLine1"
                value={employeeModal.addressLine1}
                onChange={(e) => handleModalChange(e)}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "addressLine1",
                  employeeModal.addressLine1,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">Address 2</Typography>
              <Input
                type="text"
                placeholder="Enter address 2"
                className="custom-select py-3"
                name="addressLine2"
                value={employeeModal.addressLine2}
                onChange={(e) => handleModalChange(e)}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">State</Typography>
              <Select
                placeholder="Select state"
                allowClear
                style={{
                  width: "100%",

                  marginTop: "5px",
                }}
                name="stateList"
                value={stateList}
                onChange={(value, options) => { 
                  if (options) {
                    // normal selection
                    setStateList({
                      label: options.label,
                      value: value,
                    });
                    setCities({ label: "", value: "" });
                  } else {
                    // cleared selection
                    setStateList({ label: "", value: "" });
                  }
                }}
                className="custom-select poppins-txt"
                options={
                  !isEmpty(dropDownList.stateOptions)
                    ? dropDownList.stateOptions
                    : []
                }
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                City
                <span
                  style={{
                    color: "red",
                    marginLeft: "2px",
                  }}
                  className="poppins-txt"
                >
                  *
                </span>
              </Typography>
              <Select
                placeholder="Select city"
                allowClear
                // size="40px"
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
                name="cities"
                value={cities}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setCities({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setCities({ label: "", value: "" });
                  }
                }}
                className="custom-select"
                options={cityOptions || []}
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message("cities", cities, "required")}
              </span>
            </Col>



            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Pincode
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input
                placeholder="Enter pincode"
                className="custom-select py-3"
                name="pincode"
                value={employeeModal.pincode}
                onChange={(e) => handleModalChange(e)}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "pinCode",
                  employeeModal.pincode,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">Marital Status</Typography>
              <Radio.Group
                name="maritalStatus"
                onChange={(e) => handleModalChange(e)}
                value={employeeModal.maritalStatus}
                style={{
                  display: "flex",
                  marginTop: "8px",
                  gap: "12px",
                  fontFamily: "poppins",
                }}
              >
                <Radio value="married" className="poppins-txt">
                  Married
                </Radio>
                <Radio value="unmarried" className="poppins-txt">
                  Unmarried
                </Radio>
              </Radio.Group>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">Profile Picture</Typography>
              <div style={{ position: "relative", marginTop: 8 }}>
                <Input
                  value={fileNames}
                  placeholder="Select profile picture"
                  readOnly
                  // Clicking the input triggers the hidden file input click
                  onClick={() =>
                    document.getElementById("gallery-file-upload").click()
                  }
                  // Prefix with a filled cloud upload icon, styled larger with margin (gap)
                  prefix={
                    <CloudUploadOutlined
                      style={{
                        color: "blue",
                        fontSize: 24,
                        marginRight: 12, // Increase the gap between icon and placeholder
                      }}
                    />
                  }
                  style={{
                    cursor: "pointer",
                    paddingLeft: 8, // Adds a little more padding on the left for the text
                  }}
                />

                {/* Hidden file input overlay */}
                <input
                  id="gallery-file-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleSinglePhoto} // <- change handler name too
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                />
              </div>

              {/* Image previews */}
              {imagePreviews.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  <Typography.Text type="secondary">Preview:</Typography.Text>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(100px, 1fr))",
                      gap: 12,
                      marginTop: 12,
                    }}
                  >
                    {imagePreviews.map((img, idx) => (
                      <div key={idx} style={{ position: "relative" }}>
                        <Image
                          src={img.url}
                          width={100}
                          height={100}
                          style={{
                            objectFit: "cover",
                            borderRadius: 6,
                          }}
                          preview={true}
                        />
                        <CloseOutlined
                          onClick={() => handleRemovePreview(img.url)}
                          style={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            background: "#fff",
                            borderRadius: "50%",
                            color: "#ef3022",
                            fontSize: 14,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                            cursor: "pointer",
                            padding: 2,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Employee Type
                <span
                  style={{
                    color: "red",
                    marginLeft: "2px",
                  }}
                  className="poppins-txt"
                >
                  *
                </span>
              </Typography>
              <Select
                placeholder="Select employee type"
                allowClear
                // size="40px"
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
                name="employeeType"
                value={employeeType}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setEmployeeType({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setEmployeeType({ label: "", value: "" });
                  }
                }}
                className="custom-select"
                options={
                  !isEmpty(dropDownList) ? dropDownList.employeeTypeOptions : []
                }
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "employeeType",
                  employeeType,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} className="poppins-txt">
              <h4
                style={{
                  fontSize: "16px",
                  color: "#1890ff",
                  cursor: "pointer",
                  display: "inline-flex",
                  gap: "8px",
                  marginTop: "20px",
                }}
                className="poppins-txt"
              >
                Official Information
                <Tooltip
                  title="Official Information"
                  color="blue"
                  placement="rightTop"
                >
                  <InfoCircleOutlined
                    style={{
                      fontSize: "16px",
                      color: "#1890ff",
                      cursor: "pointer",
                    }}
                  ></InfoCircleOutlined>
                </Tooltip>
              </h4>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Department
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Select
                placeholder="Select department"
                allowClear
                style={{ marginTop: "5px", width: "100%" }}
                name="departments"
                value={departments}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDepartments({
                      label: options.label,
                      value: value,
                    });
                    setDesignations({ label: "", value: "" });
                  } else {
                    // cleared selection
                    setDepartments({ label: "", value: "" });
                  }
                }}
                className="custom-select "
                options={
                  !isEmpty(dropDownList.departmentOptions)
                    ? dropDownList.departmentOptions
                    : []
                }
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "departments",
                  departments,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Designation
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Select
                placeholder="Select designation"
                allowClear
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
                name="designations"
                value={designations}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setDesignations({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setDesignations({ label: "", value: "" });
                  }
                }}
                className="custom-select"
                options={!isEmpty(designationOptions) ? designationOptions : []}
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "designations",
                  designations,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
              className="poppins-txt"
            >
              <Typography className="poppins-txt">
                Role<span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Select
                placeholder="Select role"
                allowClear
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
                name="role"
                value={role}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setRole({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setRole({ label: "", value: "" });
                  }
                }}
                className="custom-select"
                options={
                  !isEmpty(dropDownList.roleOptions)
                    ? dropDownList.roleOptions
                    : []
                }
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message("role", role, "required")}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Employee Code
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input
                placeholder="Enter employee code"
                className="custom-select"
                name="employeeCode"
                value={employeeModal.employeeCode}
                onChange={(e) => handleModalChange(e)}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "employeeCode",
                  employeeModal.employeeCode,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Official Mail 1
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input
                type="email"
                placeholder="Enter official mail 1"
                className="custom-select"
                name="officialMail1"
                value={employeeModal.officialMail1}
                onChange={(e) => {
                  handleModalChange(e);

                  simpleValidator.current.showMessageFor(
                    "officialMail1",
                    employeeModal.officialMail1,
                    "email"
                  );

                  forceUpdate((prev) => prev + 1);
                }}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  display: "block",
                  fontFamily: "poppins",
                }}
              >
                {simpleValidator.current.message(
                  "officialMail1",
                  employeeModal.officialMail1,
                  "required|email"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography style={{ fontFamily: "Poppins" }}>
                Official Mail 2
              </Typography>
              <Input
                type="email"
                placeholder="Enter official mail 2"
                className="custom-select"
                name="officialMail2"
                value={employeeModal.officialMail2}
                onChange={(e) => {
                  handleModalChange(e);

                  simpleValidator.current.showMessageFor(
                    "officialMail2",
                    employeeModal.officialMail2,
                    "email"
                  );

                  forceUpdate((prev) => prev + 1);
                }}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  display: "block",
                  fontFamily: "poppins",
                }}
              >
                {simpleValidator.current.message(
                  "officialMail2",
                  employeeModal.officialMail2,
                  "email"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Official Mobile Number
              </Typography>
              <Input
                placeholder="Enter mobile number"
                className="custom-select"
                name="officialMobile"
                value={employeeModal.officialMobile}
                onChange={(e) => {
                  const onlyNums = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);

                  setEmployeeModal((prev) => ({
                    ...prev,
                    officialMobile: onlyNums,
                  }));

                  // Force re-render
                  forceUpdate((prev) => prev + 1);
                }}
                style={{ marginTop: "5px" }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  display: "block",
                  fontFamily: "poppins",
                }}
              >
                {simpleValidator.current.message(
                  "officialMobile",
                  employeeModal.officialMobile,
                  "numeric|min:10|max:10"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                DOJ
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <DatePicker
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
                className="custom-select"
                name="doj"
                value={employeeModal.doj}
                onChange={(date) => handleModalDateChange("doj", date)}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "doj",
                  employeeModal.doj,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Login Shift
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Select
                placeholder="Select shift"
                allowClear
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
                name="shifts"
                value={shifts}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setShifts({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setShifts({ label: "", value: "" });
                  }
                }}
                className="custom-select"
                options={
                  !isEmpty(dropDownList.loginShiftOptions)
                    ? dropDownList.loginShiftOptions
                    : []
                }
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  display: "block",
                  fontFamily: "poppins",
                }}
              >
                {simpleValidator.current.message("shifts", shifts, "required")}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={6}
              lg={6}
              xl={6}
              style={{ marginTop: "16px" }}
            >
              <Checkbox
                style={{ marginTop: "15px" }}
                name="isCL"
                checked={isCL}
                onChange={(e) => handleCLChange(e)}
                className="poppins-txt"
                autoComplete="off"
              >
                is CL
              </Checkbox>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={6}
              lg={6}
              xl={6}
              style={{ marginTop: "16px" }}
            >
              <Checkbox
                style={{ marginTop: "15px" }}
                className="poppins-txt"
                name="isSL"
                checked={isSL}
                onChange={(e) => handleSLChange(e)}
                autoComplete="off"
              >
                is SL
              </Checkbox>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">Notes</Typography>
              <Input.TextArea
                placeholder="Enter notes"
                rows={2}
                className="py-3 poppins-txt"
                style={{ marginTop: "5px" }}
                name="notes"
                value={employeeModal.notes}
                onChange={(e) => handleModalChange(e)}
                autoComplete="off"
              />
            </Col>

            <Col xs={24} style={{ marginTop: "16px" }}>
              <h4
                style={{
                  fontSize: "16px",
                  color: "#1890ff",
                  cursor: "pointer",
                  display: "inline-flex",
                  gap: "8px",
                }}
                className="poppins-txt"
              >
                Employee Credentials
                <Tooltip
                  title="Employee Credentials"
                  color="blue"
                  placement="rightTop"
                >
                  <InfoCircleOutlined
                    style={{
                      fontSize: "16px",
                      color: "#1890ff",
                      cursor: "pointer",
                    }}
                    className="poppins-txt"
                  ></InfoCircleOutlined>
                </Tooltip>
              </h4>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                User Name
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input
                placeholder="Enter user code"
                className="custom-select"
                style={{ marginTop: "5px" }}
                name="userCode"
                value={employeeModal.userCode}
                onChange={(e) => handleModalChange(e)}
                autoComplete="off"
                disabled
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  display: "block",
                  fontFamily: "poppins",
                }}
              >
                {simpleValidator.current.message(
                  "userCode",
                  employeeModal.userCode,
                  "required"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Password
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input.Password
                placeholder="Enter password"
                className="custom-select"
                style={{ marginTop: "5px" }}
                name="password"
                value={employeeModal.password}
                onChange={(e) => {
                  handleModalChange(e); // update state
                  simpleValidator.current.showMessageFor("password"); // validate live
                  forceUpdate(4); // re-render to show validation
                }}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "password",
                  employeeModal.password,
                  "required|passwordRule"
                )}
              </span>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              style={{ marginTop: "16px" }}
            >
              <Typography className="poppins-txt">
                Confirm Password
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              </Typography>
              <Input.Password
                placeholder="Confirm password"
                className="custom-select"
                style={{ marginTop: "5px" }}
                name="confirmPassword"
                value={employeeModal.confirmPassword}
                onChange={(e) => handleModalChange(e)}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "5px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "confirmPassword",
                  employeeModal.confirmPassword,
                  `required|passwordMatch:${employeeModal.password}`
                )}
              </span>
            </Col>
          </Row>
        </div>
        <ToastContainer
          containerId="toast-1"
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          style={{
            fontSize: "12px",
          }}
          pauseOnHover
          theme="dark"
        />
      </Drawer>

      <Collapse
        defaultActiveKey={[]}
        bordered={false}
        expandIconPosition="end"
        style={{
          background: "#fff",
          borderRadius: "8px",
          marginBottom: 16,
          marginLeft: "7px",
          marginRight: "7px",
        }}
      >
        <Panel header={collapseHeader} key="1">
          <div
            style={{
              background: "#ffffff",
              margin: "4px 8px",
              padding: "16px",
              borderRadius: "8px 8px 0px 0px",
            }}
          >
            <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Employee Code</Typography>
                </div>
                <Input
                  placeholder="Enter employee code"
                  name="employeeCode"
                  value={employeeData.employeeCode}
                  onChange={handleChange}
                  type="text"
                  className="custom-select py-2"
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Department</Typography>
                </div>
                <Select
                  placeholder="Select department"
                  allowClear
                  className="custom-select"
                  name="department"
                  value={department}
                  onChange={(value, options) =>
                    options
                      ? setDepartment({ label: options.label, value })
                      : setDepartment({ label: "", value: "" })
                  }
                  options={
                    !isEmpty(dropDownList.departmentOptions)
                      ? dropDownList.departmentOptions
                      : []
                  }
                  autoComplete="off"
                  dropdownRender={(menu) => (
                    <h1 className="option-text-font">{menu}</h1>
                  )}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Designation</Typography>
                </div>
                <Select
                  placeholder="Select designation"
                  allowClear
                  className="custom-select"
                  name="designation"
                  value={designation}
                  onChange={(value, options) =>
                    options
                      ? setDesignation({ label: options.label, value })
                      : setDesignation({ label: "", value: "" })
                  }
                  options={
                    !isEmpty(designationOptionsValue)
                      ? designationOptionsValue
                      : []
                  }
                  dropdownRender={(menu) => (
                    <h1 className="option-text-font">{menu}</h1>
                  )}
                  autoComplete="off"
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">City</Typography>
                </div>
                <Select
                  placeholder="Select city"
                  allowClear
                  className="custom-select"
                  name="city"
                  value={city}
                  onChange={(value, options) =>
                    options
                      ? setCity({ label: options.label, value })
                      : setCity({ label: "", value: "" })
                  }
                  options={
                    !isEmpty(dropDownList.cityOptions)
                      ? dropDownList.cityOptions
                      : []
                  }
                  autoComplete="off"
                  dropdownRender={(menu) => (
                    <h1 className="option-text-font">{menu}</h1>
                  )}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Mobile Number</Typography>
                </div>
                <Input
                  placeholder="Enter mobile number"
                  className="custom-select py-2"
                  name="mobile"
                  value={employeeData.mobile}
                  autoComplete="off"
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
                    handleChange({
                      target: { name: e.target.name, value: onlyNums },
                    });
                  }}
                  type="text"
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">DOJ From Date</Typography>
                </div>
                <DatePicker
                  className="custom-select py-2"
                  name="dojFrom"
                  value={employeeData.dojFrom}
                  onChange={(date) => handleDateChange("dojFrom", date)}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">DOJ To Date</Typography>
                </div>
                <DatePicker
                  className="custom-select py-2"
                  name="dojTo"
                  value={employeeData.dojTo}
                  onChange={(date) => handleDateChange("dojTo", date)}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <Typography className="poppins-txt">Employee Type</Typography>
                <Select
                  placeholder="Select employee type"
                  allowClear
                  style={{ width: "100%", marginTop: "5px" }}
                  name="employeeTypes"
                  value={employeeTypes}
                  onChange={(value, options) =>
                    options
                      ? setEmployeeTypes({ label: options.label, value })
                      : setEmployeeTypes({ label: "", value: "" })
                  }
                  className="custom-select"
                  options={
                    !isEmpty(dropDownList.employeeTypeOptions)
                      ? dropDownList.employeeTypeOptions
                      : []
                  }
                  autoComplete="off"
                  dropdownRender={(menu) => (
                    <h1 className="option-text-font">{menu}</h1>
                  )}
                />
              </Col>
            </Row>

            <Row justify="end" style={{ marginTop: "8px" }}>
              <Col>
                <Button
                  className="custom-btn"
                  icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
                  size="middle"
                  onClick={onReset}
                  loading={resetLoading}
                  danger
                  style={{ marginRight: "12px" }}
                >
                  Reset
                </Button>
                <Button
                  className="custom-btn"
                  type="primary"
                  size="middle"
                  icon={<FilterOutlined style={{ fontSize: "18px" }} />}
                  htmlType="submit"
                  onClick={handleFilter}
                  loading={searchLoading}
                >
                  Apply Filter
                </Button>
              </Col>
            </Row>
          </div>
        </Panel>
      </Collapse>
      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px", // top, right, bottom, left
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Input
              placeholder="Search..."
              allowClear
              style={{ width: 250, fontFamily: "Poppins" }}
              name="searchInput"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              type="text"
              autoComplete="off"
            />

            <Button
              icon={<SearchOutlined />}
              type="primary"
              style={{ marginLeft: 8 }}
              onClick={handleSearch}
            />
          </Col>

          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={exportToCsv}
              loading={downloadLoader}
            >
              Download
            </Button>
          </Col>
        </Row>

        <Table
          loading={searchLoading}
          columns={columns}
          dataSource={filteredData.length ? filteredData : tableData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalCount, // make sure you provide total count from API
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "30"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          rowSelection={{
            selectedRowKeys: selectedRow,
            onSelectAll: (selected, selectedRows) => {
              const newSelecteds = selected
                ? selectedRows.map((n) => n._id)
                : [];
              setSelectedRow(newSelecteds);
            },
            onSelect: (record, selected) => {
              let newSelecteds = selected
                ? [...selectedRow, record._id]
                : selectedRow.filter((id) => id !== record._id);

              setSelectedRow(newSelecteds);
            },
          }}
          scroll={{ x: 765 }}
          onChange={(pagination, filters, sorter) => {
            const { current, pageSize } = pagination;
            setCurrentPage(current); // you can manage currentPage and pageSize in your component state if needed
            setPageSize(pageSize);
            const updatedParams = {
              ...searchValue,
              page: current,
              limit: pageSize,
               status :"BOTH"
            };

            setSearchValue(updatedParams);
            specificDispatch(employeeAction.loadEmployee(updatedParams));
          }}
        />

        <Space size={4}>
          <Button
            style={{
              marginTop: "20px",
              marginRight: "12px",
              background: "#f46a6a",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("delete")}
          >
            Delete
          </Button>

          <Button
            style={{
              marginTop: "20px",
              background: "#34c38f",
              marginRight: "12px",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("active")}
          >
            Active
          </Button>

          <Button
            style={{
              marginTop: "20px",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("inactive")}
          >
            Inactive
          </Button>
        </Space>

        <Modal
          open={isModalVisible}
          onCancel={handleModalClose}
          title={"Confirmation"}
          cancelText="Cancel"
          className="poppins-txt custom-active-modal"
          centered
          width={450}
          footer={null} // Remove the default footer
        // style={{ padding: 0, marginLeft: "600px" }} // Remove padding from modal
        >
          <div className="custom-modal-content">
            <p>Are you sure you want to {modalType} this employee?</p>
          </div>

          {/* Custom footer with cancel and confirm buttons */}
          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              onClick={handleModalClose}
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
            >
              Close
            </Button>
            <Button
              className="custom-btn"
              disabled={disabled}
              // onClick={handleModalClose}
              onClick={() => handleUpdateStatus(modalType)}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>

        <Modal
          title={"Confirmation"}
          open={isSecondModalOpen}
          onCancel={handleSecondModalCancel}
          cancelText="Cancel"
          className="poppins-txt custom-active-modal"
          width={450}
          footer={null}
          // style={{ padding: 0 }}
          centered
        >
          <div className="custom-modal-content">
            <p>Are you sure you want to reset this password?</p>
          </div>

          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
              onClick={handleSecondModalCancel}
            >
              Close
            </Button>
            <Button
              className="custom-btn"
              onClick={() => handleResetPassword()}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>
        <Modal
          title={"Confirmation"}
          open={approveModalOpen}
          onCancel={handleApproveModalCancel}
          cancelText="Cancel"
          className="poppins-txt custom-active-modal"
          width={450}
          footer={null}
          // style={{ padding: 0 }}
          centered
        >
          <div className="custom-modal-content">
            <p>Are you sure you want to approve this employee?</p>
          </div>

          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
              onClick={() => handleApproveModalCancel()}
            >
              Close
            </Button>
            <Button
              className="custom-btn"
              onClick={() => handleApproveUpdate()}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>
        <ToastContainer
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          style={{
            fontSize: "12px",
          }}
          pauseOnHover
          theme="dark"
        />
      </div>
    </React.Fragment>
  );
};

export default EmployeeManagementDetails;
